@if (isVisible) {
  <div class="custom-sidebar-overlay"  (click)="close()"></div>
}

<div class="custom-sidebar" [class.open]="isVisible">
  <div class="sidebar-content">
    <!-- Header -->
    <div class="header-container">
      <div class="user-info">
        <div class="user-icon" [ngStyle]="{'background-image': 'url(' + userIconUrl + ')'}"></div>
        <div class="user-text">
          <div class="user-name">{{ userName }}</div>
          <span class="email-span">{{ userEmail }}</span>
        </div>
      </div>

      <!-- Mobiler Schließen Button -->
      @if (this.screenService.smallScreen) {
        <div class="nav-item-button close-button"  (click)="close()">
          <div class="info-icon" [innerHTML]="this.svgIconService.svgCache['schließen']"></div>
        </div>
      }
    </div>

    <!-- Navigation -->
    <div class="nav-content">
      @for (item of navItems; track $index) {

        <!-- Titel -->
        @if (item.title && !item.website) {
          <div class="nav-item-title">
            {{item.name}}
          </div>
        }

        <!-- Nav-Button mit Route -->
        @if (!item.title && !item.website) {
          <div class="nav-item-button" [class.active]="isActive(item.url!)" (click)="navigateTo(item.url!)">
            <div class="info-icon" [innerHTML]="this.svgIconService.svgCache[item.icon]"></div>
            {{item.name}}
          </div>
        }

        <!-- Nav-Button mit Webseitenlink -->
        @if (!item.title && item.website) {
          <div class="nav-item-button" [class.active]="isActive(item.url!)" (click)="openWebsite(item.url!)">
            <div class="info-icon" [innerHTML]="this.svgIconService.svgCache[item.icon]"></div>
            {{item.name}}
          </div>
        }
      }
    </div>
  </div>

  <!-- Footer -->
  <div  class="nav-item-button" (click)="logout()">
    <div class="info-icon" [innerHTML]="this.svgIconService.svgCache['logout']"></div>
    Logout
  </div>
</div>

<!-- Overlay -->
@if (isVisible) {
  <div
    class="overlay"
    (click)="close()">
  </div>
}